export default __webpack_public_path__ + "static/media/logo.b468c7a8.svg";